import React from 'react';
import './Injectionsy.css';
import injectionImg from '../../../imgs/JEInjection.webp';

const Injectionsy = () => {
  return (
    <div className="injectionsy-container">
      <div className="injectionsy-text">
        <h2>INJECTION SYSTEM</h2>
        <p>
          Adopting four-column-frame structure and guided by four guide posts, the screw has an
          evenly balanced force during the process of injectiony, thus achieving steady injection
          molding.
        </p>
      </div>
      <div className="injectionsy-image">
        <img src={injectionImg} alt="Injection System" />
      </div>
    </div>
  );
};

export default Injectionsy;
